import { z } from "zod";
import { asCategoryId, ok } from "@pack-it-up/shared";
import { parseDto } from "./common.js";
export const CategoryDtoSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    name: z.string(),
    order: z.string(),
    // Per-person collapse (Issue #240). Absent on legacy docs, which carried a single
    // shared `collapsed` boolean — that field is ignored and never written again.
    collapsedBy: z.record(z.boolean()).optional(),
    emoji: z.string().optional(),
    // Absent on legacy docs = "packing" (default applied at the domain read boundary).
    kind: z.enum(["packing", "todo"]).optional(),
});
export const toDomainCategory = (raw) => {
    const p = parseDto(CategoryDtoSchema, raw, "Category");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        id: asCategoryId(d.id),
        parentId: d.parentId,
        name: d.name,
        order: d.order,
        collapsedBy: (d.collapsedBy ?? {}),
        ...(d.emoji !== undefined ? { emoji: d.emoji } : {}),
        ...(d.kind !== undefined ? { kind: d.kind } : {}),
    });
};
export const toCategoryDto = (c) => ({
    id: c.id,
    parentId: c.parentId,
    name: c.name,
    order: c.order,
    collapsedBy: c.collapsedBy,
    ...(c.emoji !== undefined ? { emoji: c.emoji } : {}),
    ...(c.kind !== undefined ? { kind: c.kind } : {}),
});
//# sourceMappingURL=category.mapper.js.map